export const FIVE_MINUTES_IN_MS = 300000;